import { ComponentStyleConfig } from '@chakra-ui/react';

const Drawer: ComponentStyleConfig = {
  // style object for base or default style
  baseStyle: {
    backgroundColor: '#ffffff',
  },
  // styles for different sizes ("sm", "md", "lg")
  sizes: {},
  // styles for different visual variants ("outline", "solid")
  variants: {},
  // default values for 'size', 'variant' and 'colorScheme'
  defaultProps: {
    size: '',
    variant: '',
    colorScheme: '',
  },
};

export default Drawer;
